import type { ComponentChildren } from 'preact';

interface ButtonProps {
  children: ComponentChildren;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  'data-testid'?: string;
}

const BASE =
  'inline-flex items-center justify-center font-semibold rounded-lg transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed';

const VARIANTS = {
  primary: 'bg-primary text-on-primary hover:bg-primary-dark',
  secondary: 'bg-secondary text-on-secondary hover:bg-secondary-bright',
  ghost: 'bg-transparent text-text hover:bg-surface-mid',
  danger: 'bg-red-600 text-white hover:bg-red-700',
};

const SIZES = {
  sm: 'text-sm px-3 py-1.5',
  md: 'text-sm px-4 py-2',
  lg: 'text-base px-6 py-3',
};

export function Button({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'md',
  disabled,
  loading,
  className = '',
  'data-testid': testId,
}: ButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={Boolean(disabled) || Boolean(loading)}
      data-testid={testId}
      className={`${BASE} ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
    >
      {loading ? <span className="mr-2 animate-spin">⟳</span> : null}
      {children}
    </button>
  );
}
